import { Component, h, Host, Prop } from '@stencil/core';
import { MultiLinkType } from './models/multiLinkType'
import { getClassNames } from '../../../lib/helper/global.helper'
import { TeaserPosition } from './models/teaserPosition'
import { TeaserColor } from './models/teaserColor'

@Component({
  tag: 'envc-carousel-item-default',
  styleUrl: 'envc-carousel-item-default.scss',
  shadow: false,
  scoped: true
})
export class EnvcCarouselItemDefault {
  /**
   * Teaser
   */
  @Prop() teaserColor: TeaserColor
  @Prop() teaserPosition: TeaserPosition
  @Prop() headline: string
  @Prop() text: string
  @Prop() teaserAdditionalClasses: string
  @Prop() headerAdditionalClasses: string

  /**
   * List Points
   */
  @Prop() listOne: string
  @Prop() listTwo: string
  @Prop() listThree: string

  /**
   * Endorsement
   */
  @Prop() endorsementText: string
  @Prop() endorsementColor: string
  @Prop() endorsementPosition: string
  @Prop() showEndorsement: boolean = true

  /**
   * Link
   */
  @Prop() linkType: MultiLinkType
  @Prop() linkUrl: string
  @Prop() targetAttribute: string
  @Prop() linkTitle: string
  @Prop() buttonColor: string
  @Prop() noFollowLinkAttribute: string
  @Prop() dataLayerEntry: string

  /**
   * Default item is a perfect base for further slide item variants, however it leads
   * to the situation that the attributes for the Host get inserted twice (once in parent, once over here)
   *
   * With the following flag it is possible to disable displaying the swiper-slide and animationConfig from within
   * this component, since it is being done in the parent slide item
   */
  @Prop() isChild: boolean


  componentDidLoad() {
    const videoCarousel = document.querySelector('.video-slider');
    const video = videoCarousel?.querySelector('video');
    const videoHeader = videoCarousel?.querySelector('header');
    const mq = window.matchMedia("(min-width: 1280px)");

    if (videoCarousel) {
      if (mq.matches) {
        videoHeader.style.height = video?.offsetHeight + 'px'
      }

      addEventListener("resize", () => {
        if (mq.matches) {
          videoHeader.style.height = video?.offsetHeight + 'px'
        } else {
          videoHeader.style.height = 'auto'
        }
      });
    }
  }

  render() {
    return (
      <Host class={getClassNames([this.isChild ? '' : 'swiper-slide'])}>
        <section data-tpl={'grid-bas-01'}>
          <div class={'container-fluid'}>
            <div class={'row'}>
              <div
                data-tpl={'sta01'}
                data-animation-container
                class={
                  getClassNames([
                    'stage',
                    'sta01--compact',
                    this.teaserColor,
                    this.teaserPosition,
                    this.teaserAdditionalClasses
                  ])
                }
              >
                {
                  (this.showEndorsement && !!this.endorsementText) && (
                    <div
                      class={
                        getClassNames([
                          'endorsement',
                          this.endorsementColor,
                          this.endorsementPosition
                        ])
                      }
                    >
                      <strong>{this.endorsementText}</strong>
                    </div>
                  )
                }
                <slot></slot>
                <header
                  style={{ opacity: '.99' }}
                  data-animation-container-reverse
                  class={this.headerAdditionalClasses}
                >
                  {
                    this.headline && (<h2 class={'h4'}>{this.headline}</h2>)
                  }
                  {
                    this.text && (<h3 class={'h5'}>{this.text}</h3>)
                  }

                  {
                    this.listOne && this.listTwo && (
                      <ul>
                        <li innerHTML={this.listOne}></li>
                        <li innerHTML={this.listTwo}></li>

                        {this.listThree && (
                          <li innerHTML={this.listThree}></li>
                        )}
                      </ul>
                    )
                  }

                  {
                    this.linkType !== MultiLinkType.NO_LINK && this.linkTitle && (
                      <a
                        href={this.linkUrl}
                        target={this.targetAttribute}
                        title={this.linkTitle}
                        rel={this.noFollowLinkAttribute}
                        data-layer-click
                        data-layer-entry={this.dataLayerEntry}
                        class={
                          getClassNames([
                            'btn',
                            this.buttonColor
                          ])
                        }
                      >
                        {this.linkTitle}
                      </a>
                    )
                  }
                </header>
              </div>
            </div>
          </div>
        </section>
      </Host>
    )
  }
}
